import React from 'react';

import { formatLargeNumber } from '../../utility/formatNumbers';
import Arc from '../../components/property-summaries/Arc';
import PurchaseInvestmentCriteria from './PurchaseInvestmentCriteria';
import Tooltip from '../../components/Tooltip';

export default function KeyMetrics({ propertyData }) {
  const capRate = propertyData.capRateInitial;
  const downPaymentAmount = propertyData.downPaymentAmount || 0;
  const overUnderPayment = propertyData.overUnderPayment || 0;
  const equityOnPurchase = downPaymentAmount + overUnderPayment;

  return (
    <section className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="rounded-lg relative bg-white p-8 flex items-center justify-center gap-4">
        <Arc
          percentage={capRate / 100}
          status={capRate >= 0 ? 'success' : 'warning'}
        />
        <div className="flex flex-col items-start">
          <h3 className="text-md text-neutral-600">Cap Rate</h3>
          <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
            {capRate}%
          </p>
        </div>
        <div className="absolute top-3 right-3">
          <Tooltip
            type="info"
            heading="Cap Rate"
            text="The ratio of Net Operating Income (NOI) to the property asset value."
            formula={['Cap Rate', '=', 'NOI', '/', 'Purchase Price']}
          />
        </div>
      </div>
      <div className="relative">
        <div className="rounded-lg relative bg-white px-6 py-4 flex items-center justify-center gap-2 overflow-hidden h-full">
          <div
            className={`w-1.5 h-full absolute left-0 top-0 ${
              equityOnPurchase >= 0 ? 'bg-primary-500' : 'bg-warning-500'
            }`}
          ></div>
          <div className="flex flex-col items-center">
            <h3 className="text-md text-neutral-600">Equity on Purchase</h3>
            <p className="text-6xl font-serif text-neutral-900 font-medium printing-text-spacing">
              ${formatLargeNumber(equityOnPurchase)}
            </p>
          </div>
        </div>
        <div className="absolute top-3 right-3">
          <Tooltip
            type="info"
            heading="Equity on Purchase"
            text="The amount of the equity that you own, based on the market value and the down payment."
          />
        </div>
      </div>
      <PurchaseInvestmentCriteria propertyData={propertyData} />
    </section>
  );
}
